export default {
  header: 'Ups, a apărut ceva neașteptat',
  text: 'Te rugăm să reîmprospătezi pagina sau apasă butonul „Înapoi la Meniu" de mai jos.',
  button: 'Înapoi la Meniu',
};
